import { component_tool ,framework_tool} from '../../../tool';
import React from 'react';
let { WizAvatarUpload,ossFileUtils } = framework_tool;
let { WizModal,Wizmessage } = component_tool;


//配置项
let componentName = 'elements'

const columns = [
   {
    name: "id",
    formItem: {
        type: "hidden"
    }
  },
  {
    title: "元素名称",
    name: "name",
    dataIndex: "name",
    searchItem: {},
    formItem: {
      rules: [{
        required: true,
        message: '请输入元素名称',
      }],
      maxlength:50,
      placeholder:"元素名称不能超过50个字。"
    },
    tableItem: {}
  },
  {
    title: "元素编码",
    name: "code",
    dataIndex: "code",
    formItem: {
      rules: [{
        required: true,
        message: '请输入元素编码',
      }],
      maxlength:50,
      placeholder:"元素编码不能超过50个字。"
    },
    searchItem: {},
    tableItem: {}
  },
  {
    title: "元素图标",
    name: "icon",
    dataIndex: "icon",
    formItem: {
      type: 'custom',
          render: (record, form) => {
            const { getFieldDecorator } =  form;
            let icon = null;
            let fileName =null;
            let fileMimeType =null;
            let fileSize =null;
            let fileUri=null;
            if(record !=null && record.icon !=null && record.icon !=null ){
              icon = record.icon;
              fileName = record.fileName;
              fileMimeType = record.fileMimeType;
              fileSize = record.fileSize;
              fileUri = record.fileUri;
            }
            return (
              <div>
                {
                  getFieldDecorator('icon', {
                    initialValue:
                    (record && record.icon) ? [
                        {fileId:icon}
                      ] : []
                })(
                    <WizAvatarUpload
                        accept={'.jpg, .jpeg, .png'}
                        listType={'picture-card'}
                        aspectRatio={1 / 1}
                        beforeUpload={(file) => {
                          let result = true;
                            const isLt1M = file.size / 1024 / 1024 < 0.195;
                            if(file.type.indexOf('image/')==-1){
                                Wizmessage.error('只能上传图片类型,请重新选择!');
                                result = false;
                            }else if (!isLt1M) {
                                Wizmessage.error('图片不得超过200k!');
                                result = false;
                            }
                            return result;
                        }}
                    />
                )
                }
              </div>)
          }
    },
    // tableItem: {
    //   render: (text, record) => {
    //     let url = ossFileUtils.getOssFile(
    //       record.icon,
    //       record.fileName,
    //       record.fileMimeType,
    //       record.fileSize,
    //       record.fileUri,
    //     ).url
    //     url = record.fileUri ? url : constants.files.sys_img_loadingFailed;
    //     return <div style={{ display: 'flex', 'justify-content': 'flex-start',  marginRight: 0, }}>
    //       <div>
    //         <img height={50} width={50} src={url} />
    //       </div>
    //     </div>
    //   }
    // }
  },
  {
    title: "类型",
    name: "type",
    dataIndex: "type",
    tableItem: {},
    dict: [
      { code: "Button", codeName: "按钮" },
    ],
    // searchItem: {
    //   type: "select"
    // },
    // formItem: {
    //   type: "select",
    //   initialValue: "Button"
    // }
  },
  {
    title: "状态",
    name: "state",
    dataIndex: "state",
    tableItem: {},
    dict: [
      { code: 1, codeName: "有效" },
      { code: 0, codeName: "无效" }
    ],
    searchItem: {
      type: "select"
    },
    formItem: {
      type: "select",
      initialValue: 1
    }
  },
  {
    title: "备注",
    name: "remark",
    dataIndex: "remark",
    formItem: {
      type:"textarea",
      maxlength:200,
      placeholder:"备注信息不能超过200个字。"
    },
    tableItem: {}
  },
  {
    title: "创建时间",
    name: "createTime",
    dataIndex: "createTime",
    tableItem: {}
  }
];

const templateConfig = {
  mainProps: {
  },
  content: {
    name: "WizTableList",
    params: {
      columns,
      searchBarProps: {
        cols: {
          xs: 12,
          md: 12,
          xl: 12
        },
        buttonSort:['add','delete','export'],
        buttons: [
          {
            key: 'export',
            custom: true,
            params: { icon: 'export', children: '导出', type: 'export'},
            customOnClick: {
              key: 'action',
              params: {
                apiKey: "export",
                apiParams: {}
              },
              formatParams:(rows,record,filters,callback)=>{
                return {...filters}
              }
            }
          }
      ]
      },
      modalFormProps: {
        key: "modal123",
        params: {
          modalParams: {
            title: "Modal",
            children: "Bla bla123 .."
          }
        },
        dataFormat:(v)=>{
          let _v = v;
          if (v && v['icon'] && v['icon'].length) {
            _v.icon = v.icon[0].fileId;//icon获取对应上传实体的fileId
          }else{
            _v.icon = "";
          }
          return _v
        }
      },
      dataTableProps: {
        rowKey: "id",
        selectType: "checkbox",
        isScroll: true,
        loading: false
      },
      rowOperateSort:['update','enableOrDisable'],
      rowOperateView: [
        {
          key: "enableOrDisable",
          custom: true,
          params: { children: "启用" },
          textFormat: {
            recordKey: 'state',
            dirt: { 0: '启用', 1: '禁用' }
          },
          customOnClick: {
            key: "action",
            params: {
              apiKey:"setElements"
            },
            formatParams: (rows, record, filters, callback) => {
              const content = `${record['state'] === 1 ? "元素禁用后，所有模块不能使用该元素，您确定要禁用吗?" : "您确定要启用该元素吗?"}`;
              WizModal.confirm({
                title: '注意', content,
                onOk: () => {
                  callback && callback({
                    state: record['state'] === 1 ?  0 : 1,
                    id: record['id'],
                  })
                },
                onCancel() { }
              });
              return null
            }
          }
        },
        /*{
          key: "deleteElementsKey",
          custom: true,
          params: { children: "删除" },
          customOnClick: {
            key: "action",
            params:{
              apiKey:"delete"
            },
            formatParams: (rows, record, filters, callback) => {
              const content = `您确定要删除？`;
              WizModal.confirm({
                title: '注意', content,
                onOk: () => {
                  callback && callback({
                    ids: [record['id']],
                    ...filters
                  })
                },
                onCancel() {}
              });
              return null;
            }
          }
        }*/

      ],
      commonOperate: {
        add: true,
        update:true,
        delete:true
      }
    }
  }
};

const apis = {
  list: {
    path: `${componentName}/getElementsListByPage`,
    payload: {
      key: `${componentName}@getElementsListByPage`,
    }
  },
  add:{
    path: `${componentName}/addElements`,
    payload: {
      key: `${componentName}@addElements`,
    }
  },
  delete:{
    path: `${componentName}/deleteElements`,
    payload: {
      key: `${componentName}@deleteElements`,
    }
  },
  update:{
    path: `${componentName}/updateElements`,
    payload: {
      key: `${componentName}@updateElements`,
    }
  },
  setElements:{
    path: `${componentName}/setElements`,
    payload: {
      key: `${componentName}@setElements`,
    }
  },
  export: {
    path: `${componentName}/export`,
    payload: {
      key: `${componentName}@export`,
      apiParams: {}
    }
  }

}


let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    ...args
  }
};

export { reduxTemplateCofig, templateConfig };
